import React from "react";
import { Button } from "antd";
import PricingBreadcrumb from "./PricingBreadcrumb";
import TopNavBar from "./TopNavBar";
import CommercialCatalogPlans from "./CommercialCatalogPlans";
import { useNavigate } from "react-router-dom";

/** /pricing/speculators : offres ciblant le profil SPECULATEUR, servies par le backend commercial. */
const SpeculatorsPricingPlans = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: "24px", maxWidth: 1200, margin: "0 auto" }}>
            <TopNavBar />
            <PricingBreadcrumb current="Spéculateurs Agricoles" /> {/* Fil d’Ariane */}
            <CommercialCatalogPlans profile="SPECULATEUR" accent="#13c2c2" onSubscribe={() => navigate("/payment-strip")} />
            <div style={{
                position: "fixed",
                bottom: 32,
                right: 32,
                zIndex: 1000
            }}>
                <Button
                    type="default"
                    size="large"
                    onClick={() => window.location.href = "/pricing"}
                >
                    ← Retour au choix
                </Button>
            </div>
        </div>
    );
};

export default SpeculatorsPricingPlans;
